import { en } from './en'
import { fa } from './fa'
// import { fr } from './fr'
import { it } from './it'
import { es } from './es'
import { zh } from './zh'
import { ar } from './ar'
import { pt } from './pt'
import { id } from './id'
import { ms } from './ms'
// import { ru } from './ru'
export const messages = {
  en,
  fa,
  it,
  es,
  zh,
  ar,
  pt,
  id,
  ms,
  // fr,
  // ru,
  // ar
}



// WEBPACK FOOTER //
// ./src/locale/index.js